/**
 * @aiPurpose imperative download trigger: create an object URL for the
 *   blob, click a hidden anchor, then revoke the URL on the next tick.
 *   Kept in the `components/` folder (not in `api/requests.ts`) because
 *   it is the only DOM coupling in the export flow — the API helper
 *   stays pure.
 */
export function triggerBrowserDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  // INVARIANT: revoke after the click handler returns so the browser has
  //   committed the navigation. Doing it synchronously can race with some
  //   browsers' download initiation.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
